import { Row } from 'antd';
import styled from 'styled-components';

export const IntegrationsWrapper = styled(Row)`
  flex: 1;
  overflow-y: auto;
  padding-bottom: 16px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
`;
